export class BaseModel {
	constructor(private id: string, private name: string, private type: string, private lastModifiedDate: string) { }

	public getUniqueId(): string {
		return this.id;
	}

	public getName(): string {
		return this.name;
	}

	public getType(): string {
		return this.type;
	}

	public getLastModifiedDate(): number {
		return new Date(this.lastModifiedDate).getTime();
	}
	public getBaseModel(): any {
		return null;
	}

	public setUniqueId(id: string): string {
		return (this.id = id);
	}

	public setName(name: string): string {
		return (this.name = name);
	}

	public setType(type: string): string {
		return (this.type = type);
	}

	public setLastModifiedDate(lastModifiedDate: string): string {
		return (this.lastModifiedDate = lastModifiedDate);
	}
}
